<div class="contracts-container">

  <!-- TAB SWITCH -->
  <div class="contracts-tabs">
    <button
      class="contracts-tab"
      [class.active]="activeTab === 0"
      (click)="activeTab = 0"
    >
      {{ "contracts.tab_generated" | translate }}
    </button>
    <button
      class="contracts-tab"
      [class.active]="activeTab === 1"
      (click)="activeTab = 1"
    >
      {{ "contracts.tab_settings" | translate }}
    </button>
  </div>

  <!-- ===== TAB 0 — CONTRATTI GENERATI ===== -->
  <ng-container *ngIf="activeTab === 0">
  <!-- HEADER -->
  <div class="contracts-header">
    <h1 class="contracts-title">{{ "contracts.title" | translate }}<br><em>{{ "contracts.title_sub" | translate }}</em></h1>
    <span class="contracts-count">{{ filteredContracts.length }} {{ "contracts.count" | translate }}</span>
  </div>

  <!-- STATISTICHE -->
  <div class="stats-row">
    <div class="stat-card">
      <span class="stat-value">{{ totalContracts }}</span>
      <span class="stat-label">{{ "contracts.total" | translate }}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value">{{ thisYearContracts }}</span>
      <span class="stat-label">{{ "contracts.this_year" | translate }}</span>
    </div>
    <div class="stat-card highlight">
      <span class="stat-value">{{ thisMonthContracts }}</span>
      <span class="stat-label">{{ "contracts.this_month" | translate }}</span>
    </div>
  </div>

  <!-- SEARCH + FILTRI ANNO -->
  <div class="search-wrapper">
    <input
      type="text"
      [(ngModel)]="searchText"
      [placeholder]="'contracts.search' | translate"
      class="search-input"
    />
    <div class="year-filters">
      <button
        class="year-btn"
        [class.active]="selectedYear === null"
        (click)="selectedYear = null">
        {{ "contracts.all_years" | translate }}
      </button>
      <button
        class="year-btn"
        *ngFor="let year of years"
        [class.active]="selectedYear === year"
        (click)="selectedYear = year">
        {{ year }}
      </button>
    </div>
  </div>

  <!-- GRIGLIA -->
  <app-load-error *ngIf="loadError" [message]="'contracts.load_error' | translate" (retry)="loadContracts()"></app-load-error>

  <div class="contracts-grid" *ngIf="filteredContracts.length > 0; else empty">
    <div class="contract-card"
         *ngFor="let contratto of filteredContracts; let i = index"
         [class.menu-open]="menuOpenId === contratto.id"
         [style.animation-delay]="i * 60 + 'ms'">

      <div class="card-index">{{ getCardIndex(contratto) }}</div>

      <div class="card-body">
        <span class="card-date">{{ contratto.data | date:'dd/MM/yyyy' }}</span>
        <h2 class="card-name">{{ contratto.nome }}</h2>
      </div>

      <span class="sign-status" [ngClass]="contratto.status">
        {{ "contracts.status." + contratto.status | translate }}
      </span>

      <div class="card-actions">
        <a class="btn-scheda" [routerLink]="['/evento', contratto.id]">
          {{ "contracts.card_link" | translate }}
        </a>
        <div class="card-more">
          <button
            type="button"
            class="btn-more"
            (click)="toggleMenu(contratto.id)"
            [attr.aria-expanded]="menuOpenId === contratto.id"
            [attr.aria-label]="'riepilogo.hero.more' | translate"
            [disabled]="regenerating === contratto.id"
          >
            <span *ngIf="regenerating !== contratto.id"><app-icon name="more" [size]="18"></app-icon></span>
            <span *ngIf="regenerating === contratto.id" class="spinner">⟳</span>
          </button>
          <div class="card-menu-backdrop" *ngIf="menuOpenId === contratto.id" (click)="menuOpenId = null"></div>
          <div class="card-menu" *ngIf="menuOpenId === contratto.id">
            <button type="button" (click)="menuOpenId = null; viewContract(contratto.id)">
              <app-icon name="eye" [size]="16"></app-icon>{{ "contracts.view" | translate }}
            </button>
            <button type="button" (click)="menuOpenId = null; download(contratto.id)">
              <app-icon name="download" [size]="16"></app-icon>{{ "riepilogo.download" | translate }}
            </button>
            <button type="button" (click)="menuOpenId = null; rigenera(contratto)">
              <app-icon name="sparkle" [size]="16"></app-icon>{{ "riepilogo.regenerate" | translate }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template #empty>
    <div class="empty-state" *ngIf="!loadError">
      <p>{{ "contracts.empty" | translate }}</p>
      <a class="btn-gold empty-cta" routerLink="/eventi">{{ "contracts.empty_cta" | translate }}</a>
    </div>
  </ng-template>
  </ng-container>

  <!-- ===== TAB 1 — IMPOSTAZIONI CONTRATTO ===== -->
  <app-contract-settings *ngIf="activeTab === 1"></app-contract-settings>

  <!-- ANTEPRIMA CONTRATTO -->
  <div class="preview-overlay" *ngIf="previewOpen" (click)="closePreview()">
    <div class="preview-container" (click)="$event.stopPropagation()">
      <div class="preview-head">
        <h3 class="preview-title">{{ "riepilogo.preview_title" | translate }}</h3>
        <button class="preview-close" (click)="closePreview()" aria-label="close">✕</button>
      </div>

      <div class="preview-summary">
        <span><strong>{{ previewContratto?.nome }}</strong></span>
        <span *ngIf="previewContratto?.data">{{ previewContratto.data | date: "dd/MM/yyyy" }}</span>
      </div>

      <iframe class="preview-frame" *ngIf="previewUrl" [src]="previewUrl"></iframe>

      <div class="preview-actions">
        <button class="btn-outline" (click)="closePreview()" [disabled]="finalizing">
          {{ "riepilogo.cancel_preview" | translate }}
        </button>
        <button class="btn-gold" (click)="finalizzaContratto()" [disabled]="finalizing">
          {{ "riepilogo.finalize" | translate }}
        </button>
      </div>
    </div>
  </div>

</div>
